import { InjectionToken } from "@angular/core";
import { SearchApiServiceInterface } from "./interfaces/search-api-service.interface";

/**
 * Injection token for the search API service implementation
 * Allows different implementations to be provided in different contexts
 */
export const SEARCH_API_SERVICE = new InjectionToken<SearchApiServiceInterface>("SEARCH_API_SERVICE");
